import React from 'react'
import {NavLink} from "react-router-dom"
import { CREATE_DOCUMENT_ROUTE, HOME_ROUTE, META_DOCUMENT_LIST_ROUTE, STATS_ROUTE } from "../../routing/consts"
import logo from '../../assets/images/logo-2.svg'
import style from './Navigation.module.scss'
import { 
    BarChartOutlined, 
    CaretDownOutlined, 
    FileAddOutlined, 
    HomeOutlined, 
    ReadOutlined,
    UserOutlined,
    LogoutOutlined
} from '@ant-design/icons'
import {Collapse, Popconfirm} from 'antd'
import { useGetDocumentCountQuery } from '../../store/api/signularisApi'
import { useAppSelector } from "../../hooks/redux";
import { RootState } from "../../store/store";

const { Panel } = Collapse;

const Navigation: React.FC<{hideMenu: boolean, openMenu: () => void}> = ({hideMenu, openMenu}) => {
    const userInfo = useAppSelector((state: RootState) => state.userinfo);
    
    const newDocs = useGetDocumentCountQuery('new', { pollingInterval: 60000 })
    const signedDocs = useGetDocumentCountQuery('signed', { pollingInterval: 60000 })
    const declinedDocs = useGetDocumentCountQuery('declined', { pollingInterval: 60000 })
    const createdDocs = useGetDocumentCountQuery('created', { pollingInterval: 60000 })
    const viewDocs = useGetDocumentCountQuery('view', { pollingInterval: 60000 })

    const handleExit = () => {
        localStorage.removeItem("token");
        window.location.href = '/';
    };

    const menu = [
        { route: HOME_ROUTE, title: 'Главная', icon: <HomeOutlined /> },
        { route: CREATE_DOCUMENT_ROUTE, title: 'Создать', icon: <FileAddOutlined /> },
        {
            title: 'Документы',
            icon: <ReadOutlined />,
            subMenu: [
                { route: '/new', title: 'Входящие', count: newDocs.data?.count },
                { route: '/signed', title: 'Подписанные', count: signedDocs.data?.count },
                { route: '/declined', title: 'Отклоненные', count: declinedDocs.data?.count },
                { route: '/created', title: 'Созданные', count: createdDocs.data?.count },
                { route: '/view', title: 'Просматриваемые', count: viewDocs.data?.count }
            ]
        },
        {
            title: 'Аналитика',
            icon: <BarChartOutlined/>,
            subMenu: [{ route: STATS_ROUTE, title: 'Статистика', count: undefined }]
        }
    ];

    return (
        <div onClick={openMenu} className={`${style.wrap} ${hideMenu ? style.hideMenu : ''}`}>
            <div className={style.logoSection}>
                <div className={style.logoTop}>
                    <img src={logo} alt="logo" className={style.logoImg} />
                    <div className={style.universityName}>
                        ФГБОУ ВО "ГГНТУ им. акад. М.Д. Миллионщикова"
                    </div>
                </div>
                <div className={style.projectTag}>Документооборот</div>
            </div>

            <nav className={style.nav} onClick={(e) => e.stopPropagation()}>
                <ul>
                    {menu.map(item => (
                        <li key={item.title} className={style.listItem}>
                            {item.route ? (
                                <NavLink to={item.route} className={({isActive}) => `${style.link} ${isActive ? style.active : ''}`}>
                                    <span className={style.icon}>{item.icon}</span>
                                    <span className={style.text}>{item.title}</span>
                                </NavLink>
                            ) : (
                                <Collapse ghost expandIconPosition="end" className={style.subMenu}
                                          expandIcon={({ isActive }) => <CaretDownOutlined rotate={isActive ? 180 : 0} />}>
                                    <Panel header={
                                        <div className={style.linkHeader}>
                                            <span className={style.icon}>{item.icon}</span>
                                            <span className={style.text}>{item.title}</span>
                                        </div>
                                    } key="1">
                                        <div className={style.subList}>
                                            {item.subMenu?.map(sub => (
                                                <NavLink 
                                                    key={sub.title} 
                                                    to={sub.route.startsWith('/') ? META_DOCUMENT_LIST_ROUTE + sub.route : sub.route} 
                                                    className={({isActive}) => `${style.subLink} ${isActive ? style.activeSub : ''}`}
                                                >
                                                    <span className={style.dot}></span>
                                                    <span className={style.subText}>{sub.title}</span>
                                                    {sub.count !== undefined && sub.count > 0 && <span className={style.badge}>{sub.count}</span>}
                                                </NavLink>
                                            ))}
                                        </div>
                                    </Panel>
                                </Collapse>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>

            <div className={style.userFooter} onClick={(e) => e.stopPropagation()}>
                <div className={style.userCard}>
                    <div className={style.userAvatar}>
                        <UserOutlined />
                    </div>
                    <div className={style.userDetails}>
                        <span className={style.userName}>{userInfo.firstname} {userInfo.lastname}</span>
                        <span className={style.userRole}>Сотрудник ГГНТУ</span>
                    </div>
                    <Popconfirm
                        title="Выйти из системы?"
                        onConfirm={handleExit}
                        okText="Да"
                        cancelText="Нет"
                        placement="topRight"
                    >
                        <button className={style.exitBtn} title="Выход">
                            <LogoutOutlined />
                        </button>
                    </Popconfirm>
                </div>
            </div>
        </div>
    );
};

export default Navigation;
